(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxRenameSite(
    $http, toastr, $filter
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/sites/renameSite/renameSite.template.html',
      link: function(scope, element) {

        (function() {
          init();
        })();

        function init () {
          scope.originalName = angular.copy(scope.context.name);
          scope.name = scope.context.name;
          scope.invalidName = true;

          element.on("keydown keypress", function (event) {
            if(event.which === 13) {
              event.preventDefault();
              scope.$apply(function (){
                if (!scope.invalidName) {
                  if (scope.context.type === 'network') {
                    scope.renameNetwork();
                  } else {
                    scope.renameSite();
                  }
                }
              });
            }
          });
        }

        scope.$watch(function() {
          return scope.context
        }, function(oldVal, newVal) {
          if (oldVal !== newVal) {
            init();
          }
        })

        scope.validateName = function () {
          if (scope.name !== scope.originalName && scope.name.length > 0) {
            scope.invalidName = false;
          } else {
            scope.invalidName = true;
          }
        }

        scope.renameSite = function () {
          scope.context.renameSite(scope.name).then(function(response) {
          }).catch(function(error){});
          element.off("keydown keypress");
          scope.callback();
        }

        scope.renameNetwork = function () {

          var patch = [{
            op: 'replace',
            path: '/name',
            value: scope.name
          }];
          $http.patch(scope.context._links.self.href, patch).then(function(response) {
            toastr.success($filter("translate")("ChangesSaved"));
          }).catch(function(error){});
          scope.callback();
        }

      }
    };
  }

  pxRenameSite.$inject = ['$http', 'toastr', '$filter'];

  angular
    .module('printix-admin')
    .directive('pxRenameSite', pxRenameSite);

})();
